// Centralised route table — no inline path strings anywhere in the FE.
// Every <Link>, <Navigate>, useNavigate(...) call references these constants.
//
// There is no standalone `/forbidden` route — `ProtectedRoute` renders
// `<ForbiddenPage />` inline on the originating URL so the address bar
// keeps the URL the user actually requested (the mockup doesn't dedicate
// a route for "forbidden" either).
export const Routes = {
  HOME: '/',
  ORDERS: '/orders',
  // CHR-03 §6 / ADR-0051 — read-only weekly transport calendar. Sub-route of
  // the orders area under the same chrome + role set; a `?week=YYYY-MM-DD`
  // (Monday) query param drives week navigation.
  ORDERS_CALENDAR: '/orders/calendar',
  // CHR-06 §1 (ID-236) — „Adresář": the third view-toggle sibling of Seznam /
  // Kalendář. Sub-route of the orders area under the same chrome + role set;
  // the shared place registry dispatchers read from and copy out of.
  ORDERS_ADDRESSES: '/orders/addresses',
  ADMIN_USERS: '/admin/users',
  ADMIN_NOTIFICATIONS: '/admin/notifications',
  CALLBACK: '/auth/callback',
} as const;

export type AppRoute = (typeof Routes)[keyof typeof Routes];
